module.exports = __webpack_public_path__ + "img/dinosaur_footprints_in_the_snow.ba8d851b.jpg";